var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ma-2",attrs:{"outlined":"","small":"","color":"red","disabled":!this.$store.state.started},on:{"click":_vm.falseStart}},[_vm._v(" Faux Départ ")])}
var staticRenderFns = []

export { render, staticRenderFns }